var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('sideMenu',{attrs:{"drawer":_vm.drawer},on:{"input":function($event){_vm.drawer = $event}}}),_c('headerBar',{attrs:{"drawer":_vm.drawer},on:{"input":function($event){_vm.drawer = $event}}}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }